import { ChevronRightIcon, XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

import { Candidacy } from "@/types";

const ScreeningQuestionWithAnswer = ({
  answer,
  question,
}: {
  answer: string;
  question: string;
}) => {
  return (
    <Collapsible className="group/collapsible" defaultOpen>
      <div className="flex flex-col gap-4 rounded-lg border border-slate-200 bg-slate-50 px-6 py-4">
        <div className="flex items-center justify-between gap-4">
          <p className="font-medium text-slate-800">{question}</p>
          <CollapsibleTrigger asChild>
            <Button className="shrink-0" size="icon" variant="ghost">
              <ChevronRightIcon className="h-4 w-4 text-slate-700 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
            </Button>
          </CollapsibleTrigger>
        </div>
        <CollapsibleContent>
          <div className="border-l border-slate-400 pl-3">
            <p className="text-sm text-slate-700">{answer}</p>
          </div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
};

const ScreeningQuestionWithoutAnswer = ({ question }: { question: string }) => {
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-6 py-4 opacity-50">
      <div className="flex items-center justify-between gap-4">
        <p className="font-medium text-slate-800">{question}</p>
        <Button className="shrink-0" size="icon" variant="ghost" disabled>
          <XIcon className="h-4 w-4 text-slate-700" />
        </Button>
      </div>
    </div>
  );
};

export const JobPipelineCandidateSheetScreeningAnswers = ({
  screeningAnswers,
}: {
  screeningAnswers: Candidacy["screeningAnswers"];
}) => {
  return (
    <div className="flex flex-col gap-2">
      {screeningAnswers?.screeningAnswers.map((screeningAnswer, index) => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        const questionWithNumber = `${index + 1}. ${screeningAnswer.question}`;

        if (screeningAnswer.answer) {
          return (
            <ScreeningQuestionWithAnswer
              answer={screeningAnswer.answer}
              key={index}
              question={questionWithNumber}
            />
          );
        }
        return (
          <ScreeningQuestionWithoutAnswer
            key={index}
            question={questionWithNumber}
          />
        );
      })}
    </div>
  );
};
